module.exports = __webpack_public_path__ + "img/logo_brick_1.c81469e2.png";